import { useCallback, useEffect, useState } from 'react';
import { DEFAULT_PDF_ROTATION, Options, ROTATION_STEP } from 'components';
import { dynamicManager } from 'pages/FormProcess/DynamicForm/DynamicManager';

import { CommentBadgeWidget } from 'pages/FormProcess/DynamicForm/Containers/DynamicViewer/components/SignatureWidgets/CommentBadgeWidget';
import { Close, Dots } from 'components/Icons';
import { useScreen } from 'hooks';
import { dynamicFormRotationChangeEffect } from 'store/effects/formProcess';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { DownloadFilesModal } from 'pages/Workshop/Forms/components/FormDetailModal/components';
import { getDynamicFormSelector } from 'store/selectors/requestFormProcess';
import styles from './styles.module.scss';
import { Icons, ICON_VARIANT_TYPE } from 'pages/FormProcess/Icons';
import { CommentBadgeIcon } from 'pages/FormProcess/DynamicForm/Containers/DynamicViewer/components/SignatureWidgets/CommentBadgeWidget/CommentBadgeIcon';
import { CommentBadgePanel } from 'pages/FormProcess/DynamicForm/Containers/DynamicViewer/components/SignatureWidgets/CommentBadgeWidget/CommentBadgePanel';

export const PreviewFormActions = (props) => {
  const [filesModalOpen, setFilesModalOpen] = useState(false);
  const [commentPanelOpen, setCommentPanelOpen] = useState(false);

  const { isMobile } = useScreen();
  const dispatch = useDispatch();

  const {
    meta,
    rotationDegree = DEFAULT_PDF_ROTATION,
    dynamicFormDocuments,
  } = useSelector(getDynamicFormSelector);

  const [docIndex, setDocIndex] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);

  const { pdfDocRefs, pdfDocAndPageRefs, isCompleted, isCompleteOrCanceledOrDeclined } = props;

  useEffect(() => {
    const handleScroll = () => {
      let currentDocId = -1;
      let currentDocIndex = 0;
      let currentPageIndex = 0;
      Object.values(pdfDocAndPageRefs.current).forEach((docItem: any) => {
        const rect = docItem?.getBoundingClientRect();

        if (rect && rect.top <= 50 && rect.bottom >= 130) {
          // const documentIndex = docItem.id.split('pdf-doc-')[1];
          const indexDetails = docItem.id.split('pdf-page-')[1];
          const [scrolledDocumentIndex, scrolledPageIndex] = indexDetails.split('-');

          currentDocId = dynamicFormDocuments?.[scrolledDocumentIndex]?.Id || -1;
          currentDocIndex = currentDocId === -1 ? 0 : +scrolledDocumentIndex;
          currentPageIndex = currentDocId === -1 ? 0 : +scrolledPageIndex;
        }
      });

      // console.log({ currentDocIndex, docIndex, currentPageIndex, pageIndex });

      setDocIndex(currentDocIndex);
      setPageIndex(currentPageIndex);
    };

    window.addEventListener('scroll', handleScroll, true);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, [pdfDocAndPageRefs]);

  const onCloseForm = () => {
    dynamicManager.handleFormExit();
  };

  const onRotationChange = () => {
    const element = document.getElementById(`page-view-${docIndex}-${pageIndex}`);

    if (element) {
      const currentRotation = element.style.getPropertyValue('rotate');

      const pageRotation = +currentRotation.split('deg')[0];

      const newRotation = pageRotation === -270 ? 0 : pageRotation - ROTATION_STEP;

      element.style.rotate = `${newRotation}deg`;
    }

    // dispatch(dynamicFormRotationChangeEffect({ rotationDegree: newRotation }));
  };

  const actionIcons = () => {
    return [
      ...(dynamicManager.canShowCommentBadge()
        ? [
            {
              label: 'Comments',
              icon: <CommentBadgeIcon headerWidget />,
              className: styles.actionIconWrapper,
              onClick: () => setCommentPanelOpen(true),
            },
          ]
        : []),
      {
        label: 'Rotate',
        onClick: onRotationChange,
        className: styles.actionIconWrapper,
        icon: <Icons variant={ICON_VARIANT_TYPE.Rotate} />,
      },
      {
        label: 'Download',
        className: styles.actionIconWrapper,
        onClick: () => setFilesModalOpen(true),
        icon: <Icons variant={ICON_VARIANT_TYPE.DownloadFile} />,
      },
      {
        label: 'Close',
        onClick: onCloseForm,
        className: styles.closeIconWrapper,
        icon: isMobile ? <Close /> : <Icons variant={ICON_VARIANT_TYPE.Cancel} />,
      },
    ];
  };

  return (
    <div className={styles.formPreviewActions}>
      {isMobile ? (
        <Options
          placement="bottom"
          options={actionIcons()}
          titleClassName={styles.optionsTitle}
          title={<Dots className={styles.optionsIcon} />}
          popoverClassName={styles.previewOptionsPopover}
          getPopupContainer={(triggerNode) => triggerNode}
        />
      ) : (
        actionIcons().map((item, index) => (
          <div key={index} className={classNames(styles.formIconWrapper, item.className)}>
            <div className={styles.iconButton} onClick={item.onClick}>
              {item.icon}
            </div>
          </div>
        ))
      )}

      <CommentBadgePanel isOpen={commentPanelOpen} setOpen={setCommentPanelOpen} />

      <DownloadFilesModal
        isOpen={filesModalOpen}
        auditTrailDocuments={[]}
        isCompleted={isCompleted}
        downloadedFileName={meta.documentName}
        onClose={() => setFilesModalOpen(false)}
        documents={dynamicManager.getDynamicDocuments()}
        formProcessPublicId={dynamicManager.getFormProcessPublicId()}
        anonymousUserDetails={dynamicManager.getAnonymousDetails()}
      />
    </div>
  );
};
